<template>
 <!-- navbar -->
 <nav class="navbar navbar-expand-lg navbar-light" style="background-color:transparent; ">
        <a class="navbar-brand " href="/" style="color: #ffffff;">
        <!-- <img :src="getImage()"  alt=""  width="50%"/> -->
        <img :src="'/imgs/tallyLogo4.png'" class="img-fluid img_size" alt="" >
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse mr-5" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item ">
                    <!--<a v-bind:href =" url('/') " class="nav-link home-nav-link  nav-link-header">Home</a> -->
                    <a href="/" class="nav-link home-nav-link nav-link-header">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/support">Features</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Pricing
                        </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Blog</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Faq's</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Support</a>
                </li>
            </ul>
        </div> 

        <div class="collapse navbar-collapse " id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <div class="flex justify-between mr-4">
              <div class="flex justify-between space-x-2">
                <img :src="'/imgs/tally_header.png'" class="img-fluid " alt="" >
                  <div class="flex flex-col ml-2">
                    <div>
                      <h6 class=" text-xs font-semibold text-gray-400" >
                          hotline 24/7
                      </h6>
                    </div>
                  <div>
                    <h6 class=" text-xs text-gray-700 font-bold">
                        (+91)9263637575
                    </h6>
                  </div>
                          
                </div>
              </div>
              </div> 
            </ul>
             <button type="button" id="button" class=" md:py-1 py-1 mr-2 px-3 rounded-md  text-white" style="background-color: #07528E;">Get Free</button>     
        </div> 
  </nav>
    <!-- navbar --> 

 <!-- banner start -->
 <section>
   <div class="rectangle ">
        <div class="container">
           <div class="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 ">
           <div class="mt-5">
              <h2 class="font-bold">What do you want to learn today?</h2> 
               <!-- Another variation with a button -->
               <div class="wrapper">
               <div class="search">
               <form role="search" method="get" class="search-form form" action="">
                   <label>
                       <span class="screen-reader-text">Search for...</span>
                       <input type="search" class="search-field" placeholder="Type something..." value="" name="s" title="" />
                   </label>
                   <input type="submit" class="search-submit button" value="&#xf002" />
               </form>
               </div>
               </div>
             <p class="mt-5 font-bold">Suggestions: <span style="color:#07528E" class="font:bold"> Data Structure, Descreate Mathematics</span></p>
           </div>
           <!-- ... -->
           <div>
               <img :src="'/imgs/ic_outstanding_management_addon.png'" class="img-fluid " alt="" >
           </div>
           </div>
        </div>   
   </div>
 </section>
 <!-- banner end -->

 <!-- card second section start -->
<section>
   <div class="container">
       <h2 class="mt-4 font-bold">Recommended addons</h2>
       <!-- card start -->       
      <div class="wrap">
         <div class="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-2 justify-between">
           <div class="filter">
             <button class="btn current" data-filter="item">All section</button>
             <button class="btn" data-filter="rocket">section A</button>
             <button class="btn" data-filter="target">section B</button>
             <button class="btn" data-filter="cookie">section C</button>
           </div>
          <div class="flex justify-end  mb-5">
          <select name="menu" class="select">
            <option class="option current" value="item" data-filter="item"  selected>Select Cource</option>
            <option class="option" value="html" data-filter="html">HTML</option>
            <option class="option" value="css" data-filter="css">CSS</option>
            <option class="option" value="js" data-filter="js">JAVASCRIPT</option>  
          </select>
          </div>
      </div>
        
 <div class="items">
   <div class="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4">
     <div class="item rocket html">
       <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">HTML A</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
        </div>
   <div class="item target html">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">HTML B</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item cookie html">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">HTML C</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item rocket css">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">CSS A</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item cookie css">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">CSS C</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item rocket js">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">JS A</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item target css">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">CSS B</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item cookie js">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">JS C</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item cookie html">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">HTML C</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item rocket html">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">HTML A</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item target js">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">JS B</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item cookie js">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">JS C</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>

   <div class="item target html">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">HTML B</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item cookie html">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">HTML C</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item rocket css">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">CSS A</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item cookie js">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">JS C</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item rocket js">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">JS A</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item target js">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">JS B</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item cookie css">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">CSS C</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item cookie js">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">JS C</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item rocket html">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">HTML A</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item target html">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">HTML B</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
   <div class="item cookie html">
     <img :src="'/imgs/ic_what_motivated.png'" class="img-fluid " alt="" >
       <div class="itm">
           <button class="rounded px-4 py-1 font-semibold" style="border: 2px solid #07528E; color:#07528E;" type="button">HTML C</button>
           <h6 class="font-bold mt-1">Data Structure & Algorithm</h6>
           <p class="text-gray-400 text-sm font-medium">Self paced course</p>
           <h5 class="font-semibold">₹ 299</h5>
           <button class="cat-red rounded w-full py-1 font-semibold" style="background: #07528E; color:white;" data-cat="cat-red">Register Now</button>
       </div>
   </div>
</div>
  
 </div>
     </div>
       <!-- card section end -->
   </div>
</section>

 <!-- footer start -->
  <div>
        <footer class="section bg-footer section-main-container">
          <div class="container">
              <div class="row">
                  <div class="col-lg-3">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Get our app</h6>
  
                          <div class="">
                              <a href=""><img
                                      src="/imgs/gp.png"
                                      class="footer-download-icon img-fluid mt-2"></a>
                              <a href=""> <img
                                      src="/imgs/gp2.png"
                                      class="footer-download-icon img-fluid mt-2"></a>
                          </div>
                      </div>
                  </div>
  
                  <div class="col-lg-3">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Resources</h6>
                          <ul class="list-unstyled footer-link">
                              <li><a href="">Menu 1</a></li>
                              <li><a href="">Menu 2</a></li>
                              <li><a href="">Menu 3</a></li>
                              <li><a href="">Menu 4</a></li>
                          </ul>
                      </div>
                  </div>
  
                  <div class="col-lg-2">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Help</h6>
                          <ul class="list-unstyled footer-link">
                              <li><a href="">Menu 1</a></li>
                              <li><a href="">Menu 2</a></li>
                              <li><a href="">Menu 3</a></li>
                              <li><a href="">Menu 4</a></li>
                          </ul>
                      </div>
                  </div>
  
                  <div class="col-lg-4">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Contact Us</h6>
                          <table>
                              <tr>
                                  <td style="text-align: center; vertical-align: middle;">
                                      <i class="fas fa-envelope contact-info-icon"></i>
                                  </td>
                                  <td>
                                      <p class="mt-2 contact-info-data"> &nbsp; abc@aruvaa.com</p>
                                  </td>
                              </tr>
                              <tr>
                                  <td style="text-align: center; vertical-align: middle;">
                                      <i class="fas fa-mobile-alt contact-info-icon"></i>
                                  </td>
                                  <td>
                                      <p class="mt-2 contact-info-data"> &nbsp; +01 123-456-7890</p>
                                  </td>
                              </tr>
                          </table>
  
   </div>
                  </div>
  
              </div>
          </div>
  
          <div class="text-center mt-5 container">
              <hr class="footer-hr">
              <div class="d-flex justify-content-center below-hr-container">
                  <a href=""><span>Privary Policy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Terms of use</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Cookie Privacy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Abuse Policy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Anti-spam Policy</span></a>
              </div>
              <p class="footer-alt mb-0 f-14 mt-2">2019 © Aruvaa, All Rights Reserved</p>
          </div>
      </footer>
  </div>
    <!-- footer end -->
</template>

<script>
export default {
mounted(){

 let dorpDownValue = "";
 let buttonValue= "";
 jQuery(function ($) {
 var $items = $(".items .item");
 var $btns = $(".filter .btn").on("click", function () {
   var active = $btns
     .removeClass("current")
     .filter(this)
     .addClass("current")
     .data("filter");
   $items
     .hide()
     .filter("." + active + dorpDownValue)
     .fadeIn(450);
     buttonValue = "."+$(this).data('filter');
 });

 //RIGHT DROPDOWN
 var $items = $(".items .item");
 var $options = $(".select .option").on("click", function () {
   var active = $options
     .removeClass("current")
     .filter(this)
     .addClass("current")
     .data("filter");
   $items
     .hide()
     .filter(buttonValue + "." + active )
     .fadeIn(400);
     dorpDownValue = "."+this.value;
 });

});

}   
}
</script>

<style >
* {
  outline: none;
}
h6{
margin-bottom: 0.1rem;
}
.img_size{
 height: auto;
 width: 156px;
}
.nav-link-header {
     color: #9c761f !important;
     font-weight: 650 !important;
     font-size: 16px;
 }
 .rectangle{
   background-color:#E5EFE7;
   /* height: 60vh; */
   background-attachment: fixed;
   background-repeat: no-repeat;
 background-attachment: fixed;
 }
 
.navbar {
  position: relative;
  display: flex;
  align-items: center; 
  padding: .5rem 5rem;
}
 
 /* searchbar start */

.search {
   margin-top:40px;
 width: 450px;
}

input[type="search"] {
 /* -webkit-appearance: none !important; */
 background-clip: padding-box;
 background-color: white;
 vertical-align: middle;
 border-radius: 0.25rem;
 border: 1px solid #e0e0e5;
 font-size: 1rem;
 width: 100%;
 line-height: 2;
 padding: 0.375rem 1.25rem;
 -webkit-transition: border-color 0.2s;
 -moz-transition: border-color 0.2s;
 transition: border-color 0.2s;
}

input[type="search"]:focus {
 transition: all 0.5s;
 border-color: #f9d342;
 outline: none;
}

form.search-form {
 display: flex;
 justify-content: center;
}

label {
 flex-grow: 1;
 flex-shrink: 0;
 flex-basis: auto;
 align-self: center;
 margin-bottom: 0;
}

input.search-field {
 margin-bottom: 0;
 flex-grow: 1;
 flex-shrink: 0;
 flex-basis: auto;
 align-self: center;
 height: 51px;
 border-top-right-radius: 0;
 border-bottom-right-radius: 0;
}

input.search-submit {
 height: 51px;
 margin: 0;
 padding: 1rem 1.3rem;
 border-top-left-radius: 0;
 border-bottom-left-radius: 0;
 border-top-right-radius: 0.25rem;
 border-bottom-right-radius: 0.25rem;
 font-family: "Font Awesome 5 Free";
 font-size: 1rem;
}

.screen-reader-text {
 clip: rect(1px, 1px, 1px, 1px);
 position: absolute !important;
 height: 1px;
 width: 1px;
 overflow: hidden;
}

.button {
 display: inline-block;
 font-weight: 600;
 font-size: 0.8rem;
 line-height: 1.15;
 letter-spacing: 0.1rem;
 text-transform: uppercase;
 background: #f9d342;
 color: #292826;
 border: 1px solid transparent;
 vertical-align: middle;
 text-shadow: none;
 -webkit-transition: all 0.2s;
 -moz-transition: all 0.2s;
 transition: all 0.2s;
}

.button:hover,
.button:active,
.button:focus {
 cursor: pointer;
 background: #d4b743;
 color: #292826;
 outline: 0;
}

 /* searchbar end */
 .wrap {
 /* max-width: 800px; */
 margin: auto;
}
button.btn {
 background: white;
 border-color: black;
 color: white;
}
button.btn:hover {
 cursor: pointer;
}

.filter {
 display: flex;
 justify-content: left;
 margin-bottom: 2rem;
}
.filter .btn {
 color: black;
 font-weight: bold;
 margin: 0.5rem;
 border-color: black;
}
.filter .btn:hover {
 border-color: rgba(24, 24, 24, 0.5);
}
.filter .btn.current {
 color: white;
 background: #07528E;
 border-color: #07528E;
}
.filter .btn.current:hover {
 opacity: 1;
}

.items {
 color: #000c1d;
 margin-bottom: 4rem;
}
.items .item {
 box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
 border-radius: 7px;
 margin-bottom: 1rem;
}
.itm{
 padding:1rem 1.5rem;
}

select{
   width: 350px;
   outline: none;
   border: 1px solid #fff;
   font-size: 1rem;
   border-radius: 0.5rem;
   box-shadow: 0 1px 4px rgb(146 161 176 / 15%);
   cursor: pointer;
}

select:focus,
select:hover{
   outline: none;
   border: 1px solid rgba(0, 0, 0, 0.329);
}
/* footer css start */
.bg-footer {
          background-color: #33383c;
          padding: 50px 0 30px;
      }
      .footer-heading {
          letter-spacing: 2px;
      }
      .footer-link a {
          color: #ffffff;
          font-size: 14px;
          transition: all 0.2s;
          text-decoration: none;
      }
      .footer-link a:hover {
          color: #FDC031;
          text-decoration: none;
      }
      .contact-info {
          color: #ffffff;
          font-size: 14px;
      }
      .footer-alt {
          color: #818282;
          font-size: 12px;
      }
      .footer-heading {
          position: relative;
          padding-bottom: -12px !important;
      }
      .footer-heading:after {
          content: '';
          width: 25px;
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
      }
      .contact-info-icon {
          color: #ffffff;
          font-size: 16px;
      }
      .contact-info-data {
          color: #ffffff;
          font-size: 16px;
          margin: 0px 0px 0px !important;
      }
      /* Extra small devices (phones, 600px and down) */
      @media  only screen and (max-width: 600px) {
          .footer-download-icon {
              width: 36%;
          }
      }
      /* Small devices (portrait tablets and large phones, 600px and up) */
      @media  only screen and (min-width: 600px) {
          .footer-download-icon {
              width: 36%;
          }  
      }
      @media  only screen and (max-width: 758px) {
    .navbar {
  padding: .5rem 1rem;
}
      }
      @media only screen and (max-width: 992px) {
    .navbar {
  padding: .5rem 1rem;
}
  }
      /* Medium devices (landscape tablets, 768px and up) */
      @media  only screen and (min-width: 768px) {
          .footer-download-icon {
              width: 40%;
          }    
      }
      /* Large devices (laptops/desktops, 992px and up) */
      @media  only screen and (min-width: 992px) {
          .footer-download-icon {
              width: 54%;
          }  
      }
      /* Extra large devices (large laptops and desktops, 1200px and up) */
      @media  only screen and (min-width: 1200px) {
          .footer-download-icon {
              width: 54%;
          }
        
      }
      .footer-get-trial-button {
          background: #FDC031;
          padding-left: 20px;
          padding-right: 20px;
          padding-top: 6px;
          padding-bottom: 6px;
          font-weight: bold;
          border-radius: 4px;
          border: none;
          color: #333;
          text-align: center;
          margin-top: 10px;
          font-weight: 500;
          transition: all 0.5s;
          cursor: pointer;
      }
      .footer-hr {
          border-color: #404447;
          background-color: #404447;
          color: #404447;
      }
      .below-hr-container {
          color: #818282;
          font-size: 12px;
      }
      .below-hr-container a {
          color: #818282;
          font-size: 12px;
      }
      .below-hr-container a:hover {
          text-decoration: none;
      }
  /* footer css end */

</style>